import { CatalogProduct, FileResult, ServiceResult } from '../models/api-shared.models';
import {
  GetProductDetailDocumentHeadersRequest,
  GetProductDetailDocumentRequest,
  GetProductDetailPdfRequest,
  GetProductDetailRequest,
  GetProductInformationAllergensAndAdditionalRequest,
  GetProductInformationDescriptionRequest,
  GetProductInformationPackingAndStorageRequest,
  GetUSDAProductDetailsRequest,
  ProductCutOffInfo,
  ProductCutOffInfoRequest,
  ProductDetailDocument,
  ProductInformationAllergensAndAdditional,
  ProductInformationDescription,
  ProductInformationPackingAndStorage,
  ReportIncorrectProductCategory,
  ReportIncorrectProductInformation,
  RequestProductNutritionalInformation,
  USDAProductDetails,
  USDAProductStatusTypeData,
} from '../models/product-detail.models';
import ApiService from './api-service';

class ProductDetailService extends ApiService {
  private static classInstance: ProductDetailService;

  private constructor() {
    super('ProductDetail');
  }

  public requestProductNutritionalInformation(request: RequestProductNutritionalInformation): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/RequestProductNutritionalInformation`, request);
  }

  public reportIncorrectProductInformation(request: ReportIncorrectProductInformation): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/ReportIncorrectProductInformation`, request);
  }

  public reportIncorrectProductCategory(request: ReportIncorrectProductCategory): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/ReportIncorrectProductCategory`, request);
  }

  public getProductDetail(request: GetProductDetailRequest): ServiceResult<CatalogProduct> {
    return this.get(`${this.baseUrl}/GetProductDetail`, request);
  }

  public getProductInformationDescription(
    request: GetProductInformationDescriptionRequest
  ): ServiceResult<ProductInformationDescription> {
    return this.get(`${this.baseUrl}/GetProductInformationDescription`, request);
  }

  public getProductInformationAllergensAndAdditional(
    request: GetProductInformationAllergensAndAdditionalRequest
  ): ServiceResult<ProductInformationAllergensAndAdditional> {
    return this.get(`${this.baseUrl}/GetProductInformationAllergensAndAdditional`, request);
  }

  public getProductInformationPackingAndStorage(
    request: GetProductInformationPackingAndStorageRequest
  ): ServiceResult<ProductInformationPackingAndStorage> {
    return this.get(`${this.baseUrl}/GetProductInformationPackingAndStorage`, request);
  }

  public getProductDetailPdf(request: GetProductDetailPdfRequest): ServiceResult<FileResult> {
    return this.post(`${this.baseUrl}/GetProductDetailReportPDF`, request);
  }

  public getProductDetailDocumentHeaders(
    request: GetProductDetailDocumentHeadersRequest
  ): ServiceResult<ProductDetailDocument[]> {
    return this.get(`${this.baseUrl}/GetProductDetailDocumentHeaders`, request);
  }

  public getProductDetailDocument(request: GetProductDetailDocumentRequest): ServiceResult<FileResult> {
    return this.get(`${this.baseUrl}/GetProductDetailDocument`, request);
  }

  public getUSDAProductDetails(request: GetUSDAProductDetailsRequest): ServiceResult<USDAProductDetails> {
    return this.post(`${this.baseUrl}/GetUSDAProductDetails`, request);
  }

  public getUSDAProductStatusTypes(request: GetUSDAProductDetailsRequest): ServiceResult<USDAProductStatusTypeData[]> {
    return this.post(`${this.baseUrl}/GetUSDAProductStatusTypes`, request);
  }

  public async getProductCutOffInfo(request: ProductCutOffInfoRequest): Promise<ServiceResult<ProductCutOffInfo>> {
    return this.post(`${this.baseUrl}/GetCustomerProductCutOff`, request);
  }

  public static getInstance(): ProductDetailService {
    if (!this.classInstance) {
      this.classInstance = new ProductDetailService();
    }
    return this.classInstance;
  }
}

export default ProductDetailService;
